import { transforms } from "./transforms";

export const labelTransform = (input: string): string => {
  let output = input;
  transforms.forEach((transform) => (output = transform(output)));
  return output;
};
